import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getVarsoUrl } from "../common/helpers/helpers";
import {
  getVariantResult,
  getRefGenome,
  getQueryType,
} from "../state/selectors/general.selectors";
import TrapScoreLink from "./atoms/TrapScoreLink";
import HelperText from "./atoms/HelperText";

const AdditionalRangeLinks = (props) => {
  let tmpl;
  const { variantResult, genomeName, queryType } = props;

  if (variantResult) {
    const { ref, chromosome, pos, mainTranscript } = variantResult;
    let trapLink;
    if (ref && ref.length < 10000) {
      let trapQuery = `${chromosome.split("chr")[1]}-${pos}`;
      if (ref.length > 1) {
        trapQuery = `${chromosome.split("chr")[1]}:${pos}-${pos + ref.length}`;
      } else {
        trapQuery = `${chromosome.split("chr")[1]}-${pos}`;
      }
      trapLink = (
        <TrapScoreLink trapQuery={trapQuery} cssClasses="varsome-gene-link" />
      );
    }

    let refseqLink;
    let ensemblLink;
    if (queryType === "transcript" && mainTranscript) {
      if (
        mainTranscript.name.startsWith("NM") ||
        mainTranscript.name.startsWith("NR")
      ) {
        refseqLink = (
          <a
            className="varsome-gene-link"
            href={getVarsoUrl(
              `https://www.ncbi.nlm.nih.gov/nuccore/${mainTranscript.name}`
            )}
            target="_blank"
          >
            RefSeq
          </a>
        );
      } else if (mainTranscript.name.startsWith("ENST")) {
        const genomeSubdomain = genomeName === "hg38" ? "www" : "grch37";
        ensemblLink = (
          <a
            className="varsome-gene-link"
            href={getVarsoUrl(
              `http://${genomeSubdomain}.ensembl.org/Homo_sapiens/Transcript/Summary?t=${mainTranscript.name}`
            )}
            target="_blank"
          >
            Ensembl
          </a>
        );
      }
    }

    let content;
    if (trapLink || refseqLink || ensemblLink) {
      content = (
        <div className="varsome-horiz-list-item tw-pb-0">
          {trapLink}
          {refseqLink}
          {ensemblLink}
        </div>
      );
    } else {
      content = <span>No additional resources for this query</span>;
    }

    tmpl = (
      <div className="varsome-container varsome-container__basic">
        <div className="varsome-title">
          <span className="tw-font-semibold">Additional resources </span>
          <HelperText fieldDescriptionKey="Additional resources" />
        </div>
        <div className="varsome-inner-container">
          <div className="varsome-horiz-flex">{content}</div>
        </div>
      </div>
    );
  }

  return <div className="varsome-result">{tmpl}</div>;
};

AdditionalRangeLinks.propTypes = {
  variantResult: PropTypes.shape({
    ref: PropTypes.string,
    chromosome: PropTypes.string,
    pos: PropTypes.number,
    mainTranscript: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  genomeName: PropTypes.string,
  queryType: PropTypes.string,
};

AdditionalRangeLinks.defaultProps = {
  variantResult: null,
  genomeName: null,
  queryType: null,
};

const mapStateToProps = (state) => ({
  variantResult: getVariantResult(state),
  genomeName: getRefGenome(state),
  queryType: getQueryType(state),
});

export default connect(mapStateToProps, {})(AdditionalRangeLinks);
